import React from 'react';
import './header.css';
import { Link } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping, faVcard } from '@fortawesome/free-solid-svg-icons';



const Header = () => {
return (
    
    // <section id='Header'>
    //     <div className='headerContent'>
    //         <span className='hello'>Hello,</span>
    //         <span className='headerText'>I'm <span className='headerName'>Aya Kamal</span> <br/>Web Developer</span>
    //         <p className='headerParag'>I'm a Skilled Web Developer with Experience in Creating <br/> Visually appealing and user friendly Websites.</p>
            
    //         <div className='btnsContact'><Link><button className='btn'><FontAwesomeIcon icon={faBagShopping} className='bagicon'/>
    //         <a href='https://drive.google.com/file/d/1_3oo8aZYxpk4n0ET47yE_G1R5ue5r8bB/view?usp=sharing'>
    //         Hire me</a></button></Link>
    //         <Link><button className='btn'><FontAwesomeIcon icon={faVcard} className='bagicon'/><a href='https://drive.google.com/file/d/1_3oo8aZYxpk4n0ET47yE_G1R5ue5r8bB/view?usp=sharing'>My Resume</a></button></Link>
    //             </div>
             

    //     </div>
 
    // </section>
    <section id="Header">
  <div className="headerContent">
    <span className="hello">Hello,</span>

    <span className="headerText">
      I'm <span className="headerName">Aya Kamal</span>
      <br />
      Web Developer
    </span>

    <p className="headerParag">
      I'm a Skilled Web Developer with Experience in Creating
      <br />
      Visually appealing and user friendly Websites.
    </p>

    <div className="btnsContact">
      <a
        href="https://drive.google.com/file/d/1_3oo8aZYxpk4n0ET47yE_G1R5ue5r8bB/view?usp=sharing"
        target="_blank"
        rel="noreferrer"
        className="btn"
      >
        <FontAwesomeIcon icon={faBagShopping} className="bagicon" />
        Hire Me
      </a>

      <a
        href="https://drive.google.com/file/d/1_3oo8aZYxpk4n0ET47yE_G1R5ue5r8bB/view?usp=sharing"
        target="_blank"
        rel="noreferrer"
        className="btn"
      >
        <FontAwesomeIcon icon={faVcard} className="bagicon" />
        My Resume
      </a>
    </div>
  </div>
</section>

)
}


export default Header;